import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { getPricingForItemTemp, updateExecutedPrice } from '../../queries/ScenarioForecast';
import BubbleChart from './BubbleChart';
import { numberFormatter } from '../../utils/formatter';
import { Button } from 'rsuite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Box } from '@mui/material';
import FilterComponent from '../../components/common/FilterComponent';
import useFilter from '../../hooks/useFilter';

type Props = {
    graphRequestData: PricingGraphRequest | null;
    setLoader: React.Dispatch<React.SetStateAction<number>>;
    handleSearch: (isAfterUpdateAction?: boolean) => void;
    filterValues: any;
}

const PricingOpportunityGraph = ({ graphRequestData, setLoader, handleSearch, filterValues }: Props) => {
    const [minYAxis, setMinYAxis] = useState<number>(0);
    const [maxYAxis, setMaxYAxis] = useState<number>(0);
    const [selectedCustomer, setSelectedCustomer] = useState<PricingGraphCustomer>();
    const allCustomerPricingData = useRef<PricingGraphCustomer[]>([]);
    const [customerPricingData, setCustomerPricingData] = useState<PricingGraphCustomer[]>([]);
    const [peerCustomerDropDown, setPeerCustomerDropDown] = useState<SelectDropDown[]>([]);
    const [filterSelectedCustomers, setFilterSelectedCustomers] = useState<string[]>([]);
    useEffect(() => {
        if (graphRequestData)
            fnFetchGraphData()
    }, [graphRequestData]);
    console.log(graphRequestData)

    const fnFetchGraphData = async () => {
        if (!graphRequestData) return
        try {
            setLoader((prev => prev + 1))
            const response = await getPricingForItemTemp(graphRequestData, selectedFilter, filterValues)
            let minYAxis = Infinity;
            let maxYAxis = -Infinity;
            const itemDescriptionList: SelectDropDown[] = response?.data.data.l4AvgPrice[graphRequestData.itemId].reduce<SelectDropDown[]>((acc, curr) => {
                if (curr.customer != graphRequestData.customer)
                    acc.push({ label: curr.customer, value: curr.customer });
                return acc
            }, [])
            setFilterSelectedCustomers(itemDescriptionList.map((v) => v.value));
            setPeerCustomerDropDown(itemDescriptionList);
            response.data.data.l4AvgPrice[graphRequestData.itemId]?.forEach((d) => {
                minYAxis = Math.min(
                    ...[d.price, d.executedPrice, d.peerPrice, minYAxis]
                );
                maxYAxis = Math.max(
                    ...[d.price, d.executedPrice, d.peerPrice, maxYAxis]
                );

                if (graphRequestData?.customer === d?.customer) {
                    setSelectedCustomer(d);
                }
            });
            minYAxis = Math.round(minYAxis);
            maxYAxis = Math.round(maxYAxis);

            if (minYAxis > 10) {
                minYAxis = minYAxis - 1;
            } else {
                minYAxis = minYAxis - 0.5;
            }

            setMinYAxis(minYAxis);
            setMaxYAxis(maxYAxis);
            allCustomerPricingData.current = response.data.data.l4AvgPrice[graphRequestData.itemId];
            setCustomerPricingData(response.data.data.l4AvgPrice[graphRequestData.itemId]);
        }
        catch (err) {

        }
        finally {
            setLoader((prev => prev - 1))
        }
    }
    const headerStyle = {
        backgroundColor: "white",
        color: "black",
        border: "1px solid #bebebe",
        borderBottom: "2px solid rgb(117, 189, 8)",
    };
    const columnStyle = {
        color: "black",
        borderRight: "0.1px solid #bebebe",
        borderBottom: "0.1px solid #bebebe",
        innerHeight: "36px",
    };
    const handleAdjustedValueChange = (value: number) => {
        setSelectedCustomer((prev) => {
            if (!prev) return prev
            const opp = calcOpprtunity(+prev.volume, prev.price, value)
            prev.opportunity = opp
            prev.executedPrice = value;
            return { ...prev }
        })
    }

    const calcOpprtunity = (quantity: number, followingPrice: number, adjustedPrice: number) => {
        return quantity * (adjustedPrice - followingPrice);
    }
    const { selectedFilter } = useFilter();
    const handleAcceptReject = async (isAccept: boolean) => {
        try {
            if (selectedCustomer && graphRequestData) {
                setLoader((prev) => prev + 1)
                const payload: PricingUpdateRejectRequest = { data: [] }
                payload.data.push({
                    customerId: selectedCustomer.customer,
                    division: graphRequestData.division,
                    executedPrice: selectedCustomer.executedPrice,
                    isAgreed: selectedCustomer.isAgreed,
                    itemId: graphRequestData.itemId,
                    opportunity: selectedCustomer.opportunity,
                    peerGroupName: selectedCustomer.peerGroupName,
                    peerPrice: selectedCustomer.peerPrice,
                    project_flag: selectedCustomer.project_flag,
                    isRecOverrideFlag: selectedCustomer?.peerPrice !== selectedCustomer?.executedPrice ? 1 : 0,
                })
                const response = await updateExecutedPrice(payload, 0, isAccept ? 0 : 1, selectedFilter, filterValues)
                fnFetchGraphData()
                handleSearch(true)
            }
        }
        catch (err) {

        }
        finally {
            setLoader((prev) => prev - 1)

        }
    }

    const handleCustomerFilterChange = (value: string[]) => {
        setFilterSelectedCustomers(value);
        const customersToShow = [...value, selectedCustomer?.customer]
        setCustomerPricingData((prev) => allCustomerPricingData.current.filter((c) => customersToShow.includes(c.customer)))
    }
    return (
        <div className='h-full'>
            {selectedCustomer && graphRequestData ? <>
                <div className="chart-title subHead">Customer Pricing and Opportunity</div>
                <div className='flex flex-col h-full gap-[2.5%]' >
                    <div className='border border-lightGrey p-[6px] bg-white  shadow-md text-[0.75vw]'>
                        <table className=" table-container table-stripped-alternate">
                            <tbody>
                                <tr>
                                    <td
                                        className=" !p-[0.5vh] w-[47.5%]  text-black border-r-[0.1px] border-b-[0.1px] border-[rgb(190, 190, 190)] ">
                                        <div className="flex justify-between">
                                            <div className="table-header-text font-semibold">
                                                Customer
                                            </div>
                                            <div className='table-cell-text'>
                                                {selectedCustomer?.customer}
                                            </div>
                                        </div>
                                    </td>
                                    <td
                                        className="!p-[0.5vh] w-[52.5%] text-black border-r-[0.1px] border-b-[0.1px] border-[rgb(190, 190, 190)] ">
                                        <div className="flex justify-between text-[0.75vw]">
                                            <div className="table-header-text font-semibold">
                                                Volume
                                            </div>
                                            <div className='table-cell-text'>
                                                ${numberFormatter(selectedCustomer?.volume ? +selectedCustomer?.volume : 0)} Per Year
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        className=" !p-[0.5vh] w-[47.5%]  text-black border-r-[0.1px] border-b-[0.1px] border-[rgb(190, 190, 190)] ">
                                        <div className="flex justify-between text-[0.75vw]">
                                            <div className="table-header-text font-semibold">
                                                Revenue
                                            </div>
                                            <div className='table-cell-text'>
                                                ${numberFormatter(selectedCustomer?.revenue || 0)}                                        </div>
                                        </div>
                                    </td>
                                    <td
                                        className="!p-[0.5vh] w-[52.5%] text-black border-r-[0.1px] border-b-[0.1px] border-[rgb(190, 190, 190)] ">
                                        <div className="flex justify-between text-[0.75vw]">
                                            <div className="table-header-text font-semibold">
                                                Opportunity at Target Price
                                            </div>
                                            <div className='table-cell-text'>
                                                ${numberFormatter(selectedCustomer?.opportunity || 0)} Per Year
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='border border-lightGrey p-[6px] bg-white  shadow-md h-full'>
                        {graphRequestData && selectedCustomer &&
                            <div className='flex flex-col h-full'>
                                <div className='flex'>

                                    <div className="w-full flex justify-center items-center">
                                        <Box
                                            component={"span"}
                                            className='flex items-center pr-1 font-black'
                                            sx={{ color: "rgba(255, 99, 132)" }}
                                        >
                                            ----
                                        </Box>
                                        <span
                                            className='chart-legend flex items-center'
                                        >
                                            Target Price
                                        </span>
                                    </div>
                                    <div className=''>
                                        <FilterComponent
                                            type="multi"
                                            filterName="Customer Class"
                                            options={peerCustomerDropDown}
                                            labelKey="label"
                                            valueKey="value"
                                            loading={false}
                                            placeholder='select'
                                            onFilterChange={(value: string[]) => {
                                                handleCustomerFilterChange(value)
                                            }}
                                            value={filterSelectedCustomers || undefined}
                                            cleanable={false}
                                        />
                                    </div>
                                </div>
                                <div className='flex h-full items-center '>
                                    <Box className='w-[50%]' sx={{ height: `calc(85%)` }}>
                                        <BubbleChart maxYAxis={maxYAxis} minYAxis={minYAxis} customerData={customerPricingData} selectedCustomerData={selectedCustomer} />
                                    </Box>
                                    <div className='w-[50%]'>
                                        <table className='table-container table-stripped-alternate text-[0.75vw]'>
                                            <thead>
                                                <tr className='text-[0.75vw] '>
                                                    <Box component={"th"} className='table-header-text alignCenter p-[0.5vw] font-semibold' sx={headerStyle}>Item</Box>
                                                    <Box component={"th"} className='table-header-text alignCenter p-[0.5vw] font-semibold' sx={headerStyle}>Item ID - {graphRequestData?.itemId}</Box>
                                                </tr>
                                            </thead>
                                            <tbody className='border-l-[1px] border-lightGrey text-[0.75vw]'>
                                                <tr>
                                                    <Box className='table-cell-text alignCenter p-[0.5vw]' component={"td"} sx={columnStyle}>Volume</Box>
                                                    <Box className='table-cell-text alignCenter p-[0.5vw]' component={"td"} sx={columnStyle}>{numberFormatter(selectedCustomer?.volume ? +selectedCustomer.volume : 0)}</Box>
                                                </tr>
                                                <tr>
                                                    <Box className='table-cell-text alignCenter p-[0.5vw]' component={"td"} sx={columnStyle}>Current Price ($)</Box>
                                                    <Box className='table-cell-text alignCenter p-[0.5vw]' component={"td"} sx={columnStyle}>${numberFormatter(selectedCustomer?.price ? +selectedCustomer.price : 0)}</Box>
                                                </tr>
                                                <tr>
                                                    <Box className='table-cell-text alignCenter p-[0.5vw]' component={"td"} sx={columnStyle}>Target Price ($)</Box>
                                                    <Box className='table-cell-text alignCenter p-[0.5vw]' component={"td"} sx={columnStyle}>${numberFormatter(selectedCustomer?.peerPrice ? +selectedCustomer.peerPrice : 0)}</Box>
                                                </tr>
                                                <tr>
                                                    <Box className='table-cell-text alignCenter p-[0.5vw]' component={"td"} sx={columnStyle}> Adjusted Price ($)</Box>
                                                    <Box className='table-cell-text alignCenter p-[0.5vw]' component={"td"} sx={columnStyle}>
                                                        <input type="number" className="border border-[#BEBEBE] p-1 rounded-sm bg-[#F1F1F1]" value={selectedCustomer?.executedPrice} onChange={(e) => {
                                                            handleAdjustedValueChange(e.target.value ? +e.target.value : 0)
                                                        }} />

                                                    </Box>
                                                </tr>
                                                <tr>
                                                    <Box className='table-cell-text alignCenter p-[0.5vw]' component={"td"} sx={columnStyle}>Opportunity</Box>
                                                    <Box className='table-cell-text alignCenter p-[0.5vw]' component={"td"} sx={columnStyle}>${numberFormatter(selectedCustomer?.opportunity ? +selectedCustomer.opportunity : 0)}</Box>
                                                </tr>
                                                <tr>
                                                    <Box className='table-cell-text alignCenter p-[0.5vw]' component={"td"} sx={columnStyle}>Accept</Box>
                                                    <Box className='table-cell-text alignCenter p-[0.5vw]' component={"td"} sx={columnStyle} onClick={(e) => e.stopPropagation()}>
                                                        <FontAwesomeIcon
                                                            icon={
                                                                faCheck
                                                            }
                                                            className={`!mr-[2vh] !ml-[1.8vh] !h-[2.5vh] !p-[1%]  ${selectedCustomer.isAgreed ? "rejectIcon" : "acceptIcon"} cursor-pointer`}
                                                            onClick={(e) => { e.stopPropagation(); handleAcceptReject(!selectedCustomer.isAgreed) }}
                                                        />
                                                    </Box>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>}
                    </div>
                </div> </> :
                <div className="flex justify-center items-center basis-[60vw]">
                    <span className="text-[2.5vh] font-normal italic text-[#000]">
                        Click on item from left table to get the detailed view
                    </span>
                </div>}
        </div>
    )
}

export default PricingOpportunityGraph